<template>
    <rkm-modal
        :title="title"
        @hide="hide"
        extra-large
        ref="RkmModal"
    >
        <rkm-row>
            <rkm-col cols="12">
                <span v-html="item ? item.mensagem : null" />
            </rkm-col>
        </rkm-row>

        <template v-slot:footer="{cancel}">
            <rkm-button
                @click="cancel"
                color="secondary"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({quantidadeNotificacoesNaoLidas: 'getQuantidadeNotificacoesNaoLidas'}),
        title() {
            return this.item ? `${this.item.tipoNome} - ${this.item.titulo}` : null
        },
    },
    created() {
        this.repositories = {
            notificacao: this.getConectaSusRepository('administracao.notificacao'),
        }
    },
    data: () => ({
        item: null,
    }),
    methods: {
        ...mapActions([
            'setLoading',
            'setQuantidadeNotificacoesNaoLidas',
            'unsetLoading',
        ]),
        open(item) {
            this.item = item
            this.$refs.RkmModal.show()
        },
        hide() {
            if (this.item.visualizado) return

            const request = {
                lotacaoId: this.item.lotacaoId,
                visualizado: true,
            }

            this.setLoading()

            this.repositories.notificacao.patch(this.item.id, this.camelObjectKeysToSnakeRecursive(request))
                .then(() => {
                    this.item.visualizado = true
                    this.setQuantidadeNotificacoesNaoLidas(this.quantidadeNotificacoesNaoLidas - 1)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, repository, stringCase],
}
</script>